import React, { useState, useEffect } from "react";
import "./FAQsPage.css";
import AOS from "aos";
import "aos/dist/aos.css";

const faqs = [
  {
    question: "What services does Dr. Chavan Multispeciality Hospital provide?",
    answer:
      "Dr. Chavan Multispeciality Hospital offers a wide range of services, including general medicine, ICU, 24/7 emergency care, and more."
  },
  {
    question: "Is the hospital equipped for emergency care?",
    answer:
      "Yes, the hospital provides 24/7 emergency care with state-of-the-art equipment and trained staff."
  },
  {
    question:
      "Are there specialized facilities for maternity and child care?",
    answer:
      "Yes, our hospital has specialized maternity wards, and pediatric care units for comprehensive child and maternal health services."
  },
  {
    question:
      "Does the hospital have experienced specialist doctors?",
    answer:
      "Yes, Dr. Chavan Multispeciality Hospital has a team of highly qualified and experienced specialist doctors across various medical fields to provide top-quality care."
  },
  {
    question:
      "Are there facilities for minimally invasive and laparoscopic surgeries?",
    answer:
      "Yes, the hospital is equipped with modern operation theatres and technology for minimally invasive procedures and laparoscopic surgeries, ensuring faster recovery and minimal scarring."
  },
  {
    question:
      "How can I book an appointment with a doctor at the hospital?",
    answer:
      "Appointments can be booked easily via our hospital website, by calling the reception, or through WhatsApp for convenient scheduling with your preferred doctor."
  }
];

const FAQsPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true
    });

    // SEO: Meta Tags
    document.title = "FAQs | Dr. Chavan Multispeciality Hospital, Indapur";

    const metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    metaDescription.content =
      "Find answers to frequently asked questions about Dr. Chavan Multispeciality Hospital's services, emergency care, doctors, maternity, pediatric care, surgeries, appointments, and more.";
    document.head.appendChild(metaDescription);

    const metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content =
      "FAQs hospital Indapur, Dr. Chavan Hospital FAQs, appointment booking, emergency care, maternity, pediatric, laparoscopic surgery";
    document.head.appendChild(metaKeywords);

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = "https://drchavanhospital.in/faqs";
    document.head.appendChild(canonical);

    // JSON-LD FAQPage schema
    const script = document.createElement("script");
    script.type = "application/ld+json";
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };
    script.text = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(metaDescription);
      document.head.removeChild(metaKeywords);
      document.head.removeChild(canonical);
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="faqs-page">
      <div className="faqs-container">
        <div className="faqs-left">
          <p
            className="faqs-small-title"
            data-aos="slide-up"
            data-aos-delay="100"
          >
            FREQUENTLY ASKED
          </p>

          <h1 data-aos="slide-up" data-aos-delay="200">
            What Can We Help With Today?
          </h1>

          <div className="faqs-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                {/* Keep h3 to preserve original UI */}
                <h3 className="faq-question">{faq.question}</h3>

                <div className="faq-answer-wrapper">
                  {activeIndex === index && (
                    <p className="faq-answer">{faq.answer}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="faqs-right">
          <img
            src="./images/faq-doctor.webp"
            alt="Doctor assisting patient"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;
